import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { supabase } from "../supabaseClient";
import { useAuth } from "../context/AuthProvider";

export default function ProtectedRoute({ children }) {
  const { session, initialized } = useAuth();
  const location = useLocation();

  // ✅ extra wait window to avoid false "logged out" after payment redirect
  const [checking, setChecking] = useState(true);
  const [fallbackSession, setFallbackSession] = useState(null);

  useEffect(() => {
    let alive = true;

    const run = async () => {
      // wait until AuthProvider says it's initialized
      if (!initialized) return;

      // if already have session, no need
      if (session) {
        if (alive) setChecking(false);
        return;
      }

      // ✅ IMPORTANT: give Supabase time to restore session after external redirect
      for (let i = 0; i < 25; i++) {
        const { data } = await supabase.auth.getSession();
        if (data?.session) {
          if (alive) setFallbackSession(data.session);
          break;
        }
        await new Promise((r) => setTimeout(r, 150));
      }

      if (alive) setChecking(false);
    };

    run();
    return () => {
      alive = false;
    };
  }, [initialized, session]);

  if (!initialized || checking) {
    return (
      <div className="min-h-screen flex items-center justify-center text-pink-400">
        Restoring session…
      </div>
    );
  }

  const effectiveSession = session || fallbackSession;

  if (!effectiveSession) {
    const returnUrl = location.pathname + location.search;

    // prevent redirect loop
    if (location.pathname === "/login" || location.pathname === "/auth/callback") {
      return <Navigate to="/login" replace />;
    }

    localStorage.setItem("redirect_after_login", returnUrl);
    return <Navigate to={`/login?return=${encodeURIComponent(returnUrl)}`} replace />;
  }

  return children;
}